import axios from 'axios';
import API_BASE_URL from '../config/api';

// Generate or retrieve persistent anonymous visitor ID
const getVisitorId = () => {
    let id = localStorage.getItem('nai_visitor_id');
    if (!id) {
        id = 'vis_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('nai_visitor_id', id);
    }
    return id;
};

// Generate or retrieve session ID (expires when tab/browser closes)
const getSessionId = () => {
    let id = sessionStorage.getItem('nai_session_id');
    if (!id) {
        id = 'ses_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
        sessionStorage.setItem('nai_session_id', id);
    }
    return id;
};

/**
 * Sends a tracking hit to the analytics endpoint.
 * Ignores admin portal routes so staff actions don't inflate public traffic.
 */
export const trackPageView = (path, title) => {
    try {
        // Do not track internal admin screens
        if (
            window.location.hostname.startsWith('admin.') ||
            path.startsWith('/dashboard') ||
            path.startsWith('/login') ||
            path.startsWith('/portal-manage-login')
        ) {
            return;
        }

        const payload = {
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path: path || window.location.pathname,
            url: window.location.href,
            title: title || document.title || 'NAI India',
            referrer: document.referrer || '',
            screen_width: window.innerWidth,
            is_heartbeat: false,
        };

        axios.post(`${API_BASE_URL}analytics/track/`, payload, {
            headers: { 'Content-Type': 'application/json' },
            timeout: 5000,
        }).catch(() => {
            // Silently swallow tracking errors to never interrupt visitor browsing
        });
    } catch (e) {
        // Silent
    }
};

/**
 * Sends a lightweight heartbeat ping to keep "Currently Online" active.
 */
export const sendHeartbeat = () => {
    try {
        if (document.hidden || window.location.hostname.startsWith('admin.')) return;

        const payload = {
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path: window.location.pathname,
            screen_width: window.innerWidth,
            is_heartbeat: true,
        };

        axios.post(`${API_BASE_URL}analytics/track/`, payload, {
            headers: { 'Content-Type': 'application/json' },
            timeout: 5000,
        }).catch(() => {});
    } catch (e) {}
};
